import {
    TimerAlarmSoundsMap,
    TimerSoundType,
} from "@lifeat/shared/data-models/widget/Pomodoro/PomodoroWidgetSettingsEntity";
import { DEFAULT_ALARM_OBJ } from "@lifeat/shared/widget/PomodoroTimerConstants";

export function getAlarmSound(alarmSoundOptions: TimerAlarmSoundsMap, key: string): TimerSoundType {
    const sound = alarmSoundOptions[key];
    return sound ? sound : DEFAULT_ALARM_OBJ[Object.keys(DEFAULT_ALARM_OBJ)[0]];
}

export function getTimerDisplayText(totalMillis: number): string {
    const totalSeconds = Math.floor(totalMillis / 1000);
    const mins = Math.max(Math.floor(totalSeconds / 60), 0);
    const secs = Math.max(totalSeconds % 60, 0);

    const minsText: string = mins < 10 ? `0${mins}` : `${mins}`;
    const secsText: string = secs < 10 ? `0${secs}` : `${secs}`;

    return `${minsText}:${secsText}`;
}
